exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".answerScoringDetails .essayText{width:100%!important;overflow:hidden;overflow-wrap:break-word;border:1px solid #ddd;border-radius:5px;padding:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/answers/answer_scoring_details.scss
// module id = 1503
// module chunks = 0